define([
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/actions/MessageCenterActions',
], (Immutable, _, Util, Actions) => {
  const initialState = Immutable.Map({
    activeCampaign: null,
    returnView: null,
    campaigns: Immutable.List(),
    campaign: Immutable.Map(),
    errors: Immutable.Map(),
    loading: false,
    sending: false,
    fetchedAt: 0,
    textFilter: '',
  });

  const actionHandlers = {};

  actionHandlers[Actions.UPDATE_CAMPAIGNS_SETTING] = (state, action) => (
    state.set(action.setting, action.value)
  );

  actionHandlers[Actions.INVALIDATE_CAMPAIGN_CACHE] = state => state.set('fetchedAt', 0);

  actionHandlers[Actions.RESET_CAMPAIGN_ERRORS] = state => state.set('errors', Immutable.Map());

  actionHandlers[Actions.REQUEST_CAMPAIGN] = state => state.set('sending', true);

  actionHandlers[Actions.RECEIVE_CAMPAIGN] = (state, action) => {
    let retState = state.set('sending', false);

    const campaign = Immutable.fromJS(action.campaign);

    retState = retState.set('campaign', campaign);
    retState = retState.deleteIn(['errors', 'fetch']);
    retState = retState.set('fetchedAt', Date.now());

    return retState;
  };

  actionHandlers[Actions.ERROR_CAMPAIGN] = (state, action) => {
    const code = action.code;
    const error = action.error;

    const retState = state.set('sending', false);

    return retState.mergeIn(['errors'], { [code]: `${error}` });
  };

  actionHandlers[Actions.REQUEST_CAMPAIGNS] = state => state.set('loading', true);

  actionHandlers[Actions.RECEIVE_CAMPAIGNS] = (state, action) => {
    let retState = state.set('loading', false);

    const campaigns = Immutable.fromJS(action.campaigns.campaigns);

    retState = retState.set('campaigns', campaigns);
    retState = retState.set('fetchedAt', new Date());
    retState = retState.deleteIn(['errors', 'fetch']);
    retState = retState.set('fetchedAt', Date.now());

    return retState;
  };

  actionHandlers[Actions.ERROR_CAMPAIGNS] = (state, action) => {
    const code = action.code;
    const error = action.error;

    const retState = state.set('loading', false);

    return retState.mergeIn(['errors'], { [code]: `${error}` });
  };

  actionHandlers[Actions.UPDATE_CAMPAIGN_TEXT_FILTER] = (state, action) => state.set('textFilter', action.filter);

  actionHandlers[Actions.RECEIVE_CAMPAIGN_STATS] = (state, action) => {
    const campaigns = state.get('campaigns').toJS();
    const { campaign_id, stats } = action.campaign;

    const campaign = _.findWhere(campaigns, { id: campaign_id });

    if (campaign) {
      campaign.stats = stats;
    }

    const retState = state.set('campaigns', Immutable.fromJS(campaigns));

    return retState;
  };

  actionHandlers[Actions.UPDATE_ACTIVE_CAMPAIGN] = (state, action) => {
    const campaign = action.campaign;
    let retState = state;

    retState = retState.set('activeCampaign', campaign);

    return retState;
  };

  actionHandlers[Actions.UPDATE_RETURN_VIEW_SETTING] = (state, action) => {
    const appView = action.appView;
    let retState = state;

    retState = retState.set('returnView', appView);

    return retState;
  };

  actionHandlers[Actions.RECEIVE_AND_SET_ACTIVE_CAMPAIGN] = (state, action) => {
    let campaign = action.campaign;
    let retState = state.set('loading', false);

    const activeCampaign = state.get('activeCampaign');

    if (activeCampaign && campaign && campaign.state === 'template') {
      campaign = { ...activeCampaign,
        body: campaign.body,
        template: campaign.template,
        template_id: campaign.id,
        template_name: campaign.name,
        changed: true,
      };
    }

    retState = retState.set('activeCampaignFetchedAt', new Date());
    retState = retState.set('activeCampaign', campaign);
    retState = retState.deleteIn(['errors', 'fetch']);

    return retState;
  };

  actionHandlers[Actions.REQUEST_CAMPAIGN_SEND_TEST] = state => state.set('loading', true);

  actionHandlers[Actions.RECEIVE_CAMPAIGN_SEND_TEST] = state => state.set('loading', false);

  return Util.createReducer(initialState, actionHandlers);
});
